<template>
  <v-container>
    <app-confirm ref="confirm"></app-confirm>
    <app-alert ref="alert"></app-alert>

    <!--Test Instructions-->
    <div v-if="!termsAgreedToAndDisplayed">
      <app-test-introduction
        :testInformation="screenMessages.Instruction"
        @termsAgreed="onTermsAgreed"
      ></app-test-introduction>
    </div>

    <!-- Test -->
    <div v-else>
      <app-test-question
        :messageText="bannerText"
        :questionDetails="questionDetails"
        :displayAlert="testAttemptDetails.showAlert"
        @onAnswerChanged="onSelectedAnswerChanged"
      ></app-test-question>
      <v-layout class="mx-auto mt-5">
        <v-flex sm3 class="mr-5" v-if="showSkipQuestion">
          <v-btn color="primary" @click="onSkipQuestion">
            <span class="controlled-font white--text">{{
              siteText.ui.skipQuestion
            }}</span>
            <v-icon right color="white"> mdi-share-outline </v-icon>
          </v-btn>
        </v-flex>
        <v-flex sm3 class="mx-5">
          <v-btn
            v-if="testAttemptDetails.showAlert === false"
            :disabled="firstQuestion"
            class="controlled-font"
            color="primary"
            @click="onPreviousQuestion"
          >
            <v-icon left>
              mdi-arrow-left-bold
            </v-icon>
            {{ siteText.ui.previous }}
          </v-btn>
        </v-flex>
        <v-flex sm3 class="mx-5">
          <v-btn
            v-if="testAttemptDetails.showAlert === false"
            :disabled="lastQuestion"
            class="primary controlled-font"
            @click="onNextQuestion()"
            >{{ siteText.ui.next }}
            <v-icon right>
              mdi-arrow-right-bold
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex :class="showSkipQuestion ? 'sm3' : 'sm6'" class="text-right">
          <v-chip class="primary px-10 controlled-font" controlled-font
            >{{ testAttemptDetails.currentQuestionId }}/{{
              testAttemptDetails.totalQuestions
            }}</v-chip
          >
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import * as consts from "../store/constants";
const NEXT_QUESTION = 1;
const PREVIOUS_QUESTION = -1;
const CLEAR_BUSY_DELAY = 500;
import Vue from "vue";
import VueExpandableImage from "vue-expandable-image";
Vue.use(VueExpandableImage);

import { mapGetters, mapActions } from "vuex";

// import appAudioPlayer from "../components/audioPlayer/AudioPlayer.vue";
// import appRadioButtons from "../components/ui/RadioButtons.vue";
// import appInformationBanner from "../components/ui/InformationBanner.vue";

import appTestQuestion from "../components/TestQuestion.vue";
import appConfirm from "../components/ui/Confirm.vue";
import appAlert from "../components/ui/Alert.vue";
import appTestIntroduction from "../components/TestIntroduction.vue";

export default {
  components: {
    // appAudioPlayer,
    // appRadioButtons,
    appTestQuestion,
    appConfirm,
    // appInformationBanner,
    appAlert,
    appTestIntroduction,
  },
  data() {
    return {
      selectedAnswer: "",
      closeImageOnBackgroundClick: true,
      aslWhite: require("../assets/images/asl-white.png"),
      toggle: false,
    };
  },
  computed: {
    ...mapGetters([
      "questionDetails",
      "testAttemptDetails",
      "siteText",
      "pages",
      "language",
      "screenMessages",
      "selectedLanguage",
      "testStage",
      "baseApiUrl",
      "termsAgreed",
      "displayCorrectAnswer",
    ]),
    answers() {
      let answers = null;
      if (this.questionDetails && this.questionDetails.answers) {
        answers = this.questionDetails.answers.map((answer) => {
          return {
            key: answer.answerChoice,
            text: `${answer.answerChoice}. ${answer.answerText}`,
          };
        });
      }
      return answers;
    },
    image() {
      return this.questionDetails.imageId
        ? `${this.baseApiUrl}Documents/TestImage/${this.questionDetails.imageId}`
        : "";
    },
    bannerText() {
      let bannerText = "";
      if (this.testStage === consts.TEST_STAGES.SKIPPED_QUESTIONS) {
        bannerText = this.screenMessages.SkippedQuestions;
      } else if (this.testAttemptDetails.isQuickFail === true) {
        bannerText = this.screenMessages.QuickFail;
      } else if (this.testAttemptDetails.isQuickPass === true) {
        bannerText = this.screenMessages.QuickPass;
      }
      return bannerText;
    },
    answerChoices() {
      return this.questionDetails && this.questionDetails.answers
        ? this.questionDetails.answers.map((answer) => {
            return answer.answerChoice;
          })
        : [];
    },
    showSkipQuestion() {
      return this.testStage !== consts.TEST_STAGES.SKIPPED_QUESTIONS;
    },
    firstQuestion() {
      return this.testAttemptDetails.currentQuestionId === 1;
    },
    lastQuestion() {
      return (
        this.testAttemptDetails.currentQuestionId >=
        this.testAttemptDetails.totalQuestions
      );
    },
    termsAgreedToAndDisplayed() {
      return (
        this.termsAgreed ||
        this.testAttemptDetails.currentTestStage > consts.TEST_STAGES.TERMS
      );
    },
  },
  methods: {
    ...mapActions([
      "SetTestDescription",
      "SetPage",
      "getQuestion",
      "saveAnswer",
      "incrementQuestionNumber",
      "completeTest",
      "skipQuestion",
      "getSkippedQuestion",
      "setQuestionNumber",
      "setTestStage",
      "setTermsAgreed",
      "finished",
      "setBusy",
      "clearBusyWithDelay",
      "getTestStatus",
    ]),
    onTermsAgreed() {
      this.setTermsAgreed(true);
    },
    async onSelectedAnswerChanged(answer) {
      this.selectedAnswer = answer;
      if (this.testAttemptDetails.showAlert) {
        this.saveAnswerGetQuestion(answer, NEXT_QUESTION);
      }
    },
    async saveAnswerGetQuestion(answer, increment) {
      let answers = ["N", "N", "N", "N"];
      answers[this.answerChoices.indexOf(answer)] = "Y";

      const saveAnswerResult = await this.saveAnswer(answers);
      if (!(await this.checkSaveAnswerResult(saveAnswerResult))) {
        const skippedQuestions = saveAnswerResult.totalSkippedQuestions > 0;
        //commented out the showReview check as it's currently not applicable//
        //this.testAttemptDetails.showReview === false &&
        console.log(this.displayCorrectAnswer, this.correctAnswer);
        if (
          this.displayCorrectAnswer === true &&
          saveAnswerResult.correctAnswer
        ) {
          await this.displayCorrectAnswerMessage(
            answer,
            saveAnswerResult.correctAnswer
          );
        }

        if (
          this.testAttemptDetails.currentQuestionId <
            this.testAttemptDetails.totalQuestions &&
          this.testStage === consts.TEST_STAGES.TEST_QUESTIONS
        ) {
          //Get question normally
          await this.getNextQuestion(increment);
        } else if (skippedQuestions) {
          if (
            this.testAttemptDetails.currentQuestionId ===
            this.testAttemptDetails.totalQuestions
          ) {
            this.setTestStage(consts.TEST_STAGES.SKIPPED_QUESTIONS);
            this.setQuestionNumber(0);
          }
          //Get Skipped Question
          await this.getNextSkippedQuestion();
        } else {
          this.completeTest();
        }
      }
    },
    async checkSaveAnswerResult(saveAnswerResult) {
      let testInterrupted = false;
      if (
        saveAnswerResult.testAttemptStatus !== consts.TEST_STATUSES.PROGRESSING
      ) {
        testInterrupted = true;
        const message =
          saveAnswerResult.testAttemptStatus === consts.TEST_STATUSES.CANCELLED
            ? this.screenMessages.CancelledTest
            : this.screenMessages.SuspendedTest;
        await this.displayTestAlert(message, true);
        this.finished();
      }

      if (saveAnswerResult.quickFailed || saveAnswerResult.quickPassed) {
        testInterrupted = true;
        const message = saveAnswerResult.quickFailed
          ? this.screenMessages.QuickFailed
          : this.screenMessages.QuickPassed;
        await this.displayTestAlert(message, false);
        //complete test here
        this.completeTest();
      }

      return testInterrupted;
    },
    async displayCorrectAnswerMessage(selectedAnswer, correctAnswer) {
      const message = String.format(
        this.siteText.ui.correctAnswerMessage,
        selectedAnswer,
        correctAnswer
      );
      await this.$refs.alert.open(this.siteText.ui.answerSaved, message);
    },
    async displayTestAlert(message) {
      await this.$refs.alert.open(this.siteText.ui.alert, message);
    },
    async onSkipQuestion() {
      let skipQuestionResult = await this.skipQuestion();
      console.log(skipQuestionResult);
      console.log(this.testAttemptDetails);
      if (
        skipQuestionResult.testAttemptStatus !==
        consts.TEST_STATUSES.PROGRESSING
      ) {
        const message =
          skipQuestionResult.testAttemptStatus ===
          consts.TEST_STATUSES.CANCELLED
            ? this.screenMessages.CancelledTest
            : this.screenMessages.SuspendedTest;
        await this.displayTestAlert(message, true);
        this.finished();
      } else if (
        this.testAttemptDetails.currentQuestionId >=
          this.testAttemptDetails.totalQuestions &&
        skipQuestionResult.totalSkippedQuestions > 0
      ) {
        this.setTestStage(consts.TEST_STAGES.SKIPPED_QUESTIONS);
        this.setQuestionNumber(0);
        await this.getNextSkippedQuestion();
      } else {
        await this.getNextQuestion(NEXT_QUESTION);
      }
    },
    async onNextQuestion() {
      if (!this.selectedAnswer || this.selectedAnswer === "") {
        await this.$refs.alert.open(
          this.siteText.ui.alert,
          this.siteText.ui.testAnswerRequired
        );
      } else {
        this.saveAnswerGetQuestion(this.selectedAnswer, NEXT_QUESTION);
      }
    },
    async onPreviousQuestion() {
      await this.saveAnswerGetQuestion(this.selectedAnswer, PREVIOUS_QUESTION);
    },
    async getNextQuestion(increment) {
      //this.clearAnswerSelection();
      this.setBusy();
      this.updateNextQuestionNumber(increment);
      await this.getQuestion(this.testAttemptDetails.currentQuestionId);
      this.setSelectedAnswer(this.questionDetails.answers);
      this.clearBusyWithDelay(CLEAR_BUSY_DELAY);
    },
    async getNextSkippedQuestion() {
      this.updateNextQuestionNumber(NEXT_QUESTION);
      try {
        await this.getSkippedQuestion();
      } catch (error) {
        console.log(error);
        if (error === consts.ERRORS.NO_SKIPPED_QUESTIONS) {
          this.completeTest();
        }
      }
      this.clearBusyWithDelay(CLEAR_BUSY_DELAY);
    },
    clearAnswerSelection() {
      this.selectedAnswer = "";
      this.$refs.answers.clearSelection();
    },
    updateNextQuestionNumber(increment) {
      this.setQuestionNumber(
        this.testAttemptDetails.currentQuestionId + increment
      );
    },
    setSelectedAnswer(answers) {
      const selectedAnswer = answers.find((value) => value.isSelected === true);
      if (selectedAnswer) {
        this.selectedAnswer = selectedAnswer.answerChoice;
      }
    },
    async setTestStartingPoint() {
      if (
        this.testAttemptDetails.currentTestStage ===
          consts.TEST_STAGES.SKIPPED_QUESTIONS &&
        this.testAttemptDetails.totalSkippedQuestions > 0
      ) {
        this.setTestStage(consts.TEST_STAGES.SKIPPED_QUESTIONS);
        this.setQuestionNumber(0);
        await this.getNextSkippedQuestion();
      } else if (
        this.testAttemptDetails.currentQuestionId >=
          this.testAttemptDetails.totalQuestions &&
        this.testAttemptDetails.currentTestStage ===
          consts.TEST_STAGES.TEST_COMPLETE_RESULTS
      ) {
        this.completeTest();
      } else {
        this.setTestStage(consts.TEST_STAGES.TEST_QUESTIONS);
        await this.getQuestion(this.testAttemptDetails.currentQuestionId);
      }
      this.SetTestDescription(this.testAttemptDetails.testName);
      console.log(this.testAttemptDetails);
      this.clearBusyWithDelay(CLEAR_BUSY_DELAY);
    },
  },
  async mounted() {
    const testAttemptStatus = await this.getTestStatus(
      this.testAttemptDetails.testAttemptId
    );
    if (testAttemptStatus.status !== consts.TEST_STATUSES.PROGRESSING) {
      const message =
        testAttemptStatus === consts.TEST_STATUSES.CANCELLED
          ? this.screenMessages.CancelledTest
          : this.screenMessages.SuspendedTest;
      await this.displayTestAlert(message);
      this.finished();
    } else {
      await this.setTestStartingPoint();
    }
  },
  watch: {
    selectedLanguage(newLanguage, oldLanguage) {
      if (newLanguage !== oldLanguage) {
        this.getQuestion(this.testAttemptDetails.currentQuestionId);
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  /*max-width: 1300px;*/
  min-height: 150px;
}
/* .v-radio {
  max-width: 300px;
} */

.white--text /deep/ label {
  color: white;
}

.white--radio /deep/ input {
  color: white;
}

.v-btn {
  border: 1px solid white !important;
}

.image {
  max-height: 300px;
  max-width: 300px;
}

.icon {
  max-height: 48px;
  max-width: 48px;
}

.btn-toggle {
  max-width: 16px;
  max-height: 16px;
  margin: -10px;
}

.btn-toggle.v-btn--outlined {
  border: 1px white solid !important;
}

body .expandable-image.expanded {
  background: rgba(0, 0, 0, 0.8);
}

.v-chip {
  min-height: 45px;
  border-radius: 10px !important;
}
</style>
